import React from "react";
// import CatergoryChart from "../../../../components/question-components/charts/QuestionCatergoryChart";
import CategoryChart from "../../../../components/question-components/charts/CategoryChart"

const QuestionCatergory = () => {
  return (
    <div>
      <div>
        <h1>Performance in questions</h1>
        <p>
          Performance data is based on first attempts only to try and make the
          comparison data as meaningful as possible. However, don't be too
          disheartened if your percentile score is low - remember that some
          users reset their accounts meaning they may have multiple "first"
          attempts.
        </p>
      </div>
      <div>
        <h5>Category performance compared to peers</h5>
        <hr />
        <div>
          <CategoryChart />
        </div>
      </div>
    </div>
  );
};

export default QuestionCatergory;
